{
  "familyId": "TOPO-WERELD-GEBERGTE",
  "questions": [
    {
      "id": "TOPO-WERELD-GEBERGTE-001",
      "familyId": "TOPO-WERELD-GEBERGTE",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_gebergte_wereld",
      "questionType": "multiple_choice",
      "question": "Op welk continent liggen de Himalaya?",
      "options": ["Azië", "Europa", "Afrika", "Zuid-Amerika"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "De Himalaya", "content": "De Himalaya liggen in Azië, op de grens van India, Nepal, Bhutan en China/Tibet. De Mount Everest (8.849 m) is de hoogste berg ter wereld.", "icon": "lightbulb"}}],
      "conceptId": "himalaya_continent",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De Himalaya liggen in Azië, op de grens van India en China/Tibet. De Mount Everest, de hoogste berg ter wereld, ligt in de Himalaya.",
        "solutionSteps": ["De Himalaya liggen in Azië", "Landen: India, Nepal, Bhutan, China/Tibet", "Hoogste berg: Mount Everest (8.849 m)"],
        "distractorExplanations": {
          "0": "Goed! De Himalaya liggen in Azië.",
          "1": "Je dacht waarschijnlijk aan de Alpen. De Alpen liggen in Europa, maar de Himalaya liggen in Azië. Onthoud: Himalaya = Azië, Alpen = Europa.",
          "2": "Je dacht waarschijnlijk aan de Kilimanjaro. Die ligt in Afrika, maar de Himalaya liggen in Azië. Onthoud: Kilimanjaro = Afrika, Himalaya = Azië.",
          "3": "Je dacht waarschijnlijk aan de Andes. De Andes liggen in Zuid-Amerika, maar de Himalaya liggen in Azië. Onthoud: Andes = Zuid-Amerika, Himalaya = Azië."
        }
      }
    },
    {
      "id": "TOPO-WERELD-GEBERGTE-002",
      "familyId": "TOPO-WERELD-GEBERGTE",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_gebergte_wereld",
      "questionType": "multiple_choice",
      "question": "Welk gebergte loopt langs de westkust van Zuid-Amerika?",
      "options": ["De Andes", "De Rocky Mountains", "De Himalaya", "De Alpen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "De Andes", "content": "De Andes zijn het langste gebergte ter wereld (~7.000 km). Ze lopen langs de westkust van Zuid-Amerika, door landen als Chili, Argentinië, Peru en Colombia.", "icon": "lightbulb"}}],
      "conceptId": "andes_ligging",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De Andes lopen langs de westkust van Zuid-Amerika. Het is het langste gebergte ter wereld (~7.000 km).",
        "solutionSteps": ["Westkust Zuid-Amerika = de Andes", "Langste gebergte ter wereld", "Landen: Chili, Argentinië, Peru, Colombia"],
        "distractorExplanations": {
          "0": "Goed! De Andes liggen langs de westkust van Zuid-Amerika.",
          "1": "Je dacht waarschijnlijk aan de Rocky Mountains. Die liggen in Noord-Amerika (VS en Canada), niet in Zuid-Amerika. Onthoud: Rocky Mountains = Noord-Amerika, Andes = Zuid-Amerika.",
          "2": "Je dacht waarschijnlijk aan de Himalaya. Die liggen in Azië, niet in Zuid-Amerika. Onthoud: Himalaya = Azië.",
          "3": "Je dacht waarschijnlijk aan de Alpen. Die liggen in Europa, niet in Zuid-Amerika. Onthoud: Alpen = Europa."
        }
      }
    },
    {
      "id": "TOPO-WERELD-GEBERGTE-003",
      "familyId": "TOPO-WERELD-GEBERGTE",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_gebergte_wereld",
      "questionType": "multiple_choice",
      "question": "Welk gebergte ligt in Noord-Amerika?",
      "options": ["De Rocky Mountains", "De Andes", "De Oeral", "De Karpaten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Rocky Mountains", "content": "De Rocky Mountains (Rotsgebergte) liggen in het westen van Noord-Amerika, van Canada tot de VS. Ze zijn ~4.800 km lang.", "icon": "lightbulb"}}],
      "conceptId": "rocky_mountains",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De Rocky Mountains liggen in het westen van Noord-Amerika (VS en Canada).",
        "solutionSteps": ["Noord-Amerika = Rocky Mountains", "Ligging: westen van VS en Canada"],
        "distractorExplanations": {
          "0": "Goed! De Rocky Mountains liggen in Noord-Amerika.",
          "1": "De Andes liggen in Zuid-Amerika, niet Noord-Amerika. Onthoud: Andes = Zuid-Amerika, Rocky Mountains = Noord-Amerika.",
          "2": "De Oeral ligt op de grens van Europa en Azië (in Rusland). Onthoud: Oeral = grens Europa/Azië.",
          "3": "De Karpaten liggen in Oost-Europa (Roemenië, Slowakije, Polen). Onthoud: Karpaten = Oost-Europa."
        }
      }
    },
    {
      "id": "TOPO-WERELD-GEBERGTE-004",
      "familyId": "TOPO-WERELD-GEBERGTE",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_gebergte_wereld",
      "questionType": "multiple_choice",
      "question": "De Kilimanjaro is de hoogste berg van Afrika. In welk land ligt deze berg?",
      "options": ["Tanzania", "Kenia", "Zuid-Afrika", "Ethiopië"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "De Kilimanjaro", "content": "De Kilimanjaro (5.895 m) ligt in Tanzania, in Oost-Afrika. Het is een vrijstaande vulkaan — geen onderdeel van een gebergte.", "icon": "lightbulb"}}],
      "conceptId": "kilimanjaro_land",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Kilimanjaro (5.895 m) ligt in Tanzania, in Oost-Afrika. Het is de hoogste berg van het Afrikaanse continent.",
        "solutionSteps": ["Kilimanjaro = hoogste berg Afrika", "Ligt in Tanzania (Oost-Afrika)", "Hoogte: 5.895 meter"],
        "distractorExplanations": {
          "0": "Goed! De Kilimanjaro ligt in Tanzania.",
          "1": "Je dacht waarschijnlijk aan Kenia. De Kilimanjaro ligt vlak bij de grens met Kenia, maar de berg zelf staat in Tanzania. Onthoud: Kilimanjaro = Tanzania.",
          "2": "Je dacht waarschijnlijk aan Zuid-Afrika. Maar de Kilimanjaro ligt in Oost-Afrika (Tanzania), niet in Zuid-Afrika. Onthoud: Tanzania ligt in het oosten van Afrika.",
          "3": "Je dacht waarschijnlijk aan Ethiopië. Maar de Kilimanjaro ligt in Tanzania, niet in Ethiopië. Onthoud: Kilimanjaro = Tanzania."
        }
      }
    },
    {
      "id": "TOPO-WERELD-GEBERGTE-005",
      "familyId": "TOPO-WERELD-GEBERGTE",
      "module": "Topo",
      "tier": 13,
      "levelCode": "B8",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_gebergte_wereld",
      "questionType": "matching",
      "question": "Koppel elk gebergte aan het juiste continent.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Himalaya", "Andes", "Rocky Mountains", "Kilimanjaro"],
        "rightItems": ["Noord-Amerika", "Azië", "Afrika", "Zuid-Amerika"],
        "correctMatches": {"0": 1, "1": 3, "2": 0, "3": 2}
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Gebergten en continenten", "content": "Himalaya = Azië. Andes = Zuid-Amerika. Rocky Mountains = Noord-Amerika. Kilimanjaro = Afrika.", "icon": "lightbulb"}}],
      "conceptId": "gebergten_continenten_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Himalaya → Azië. Andes → Zuid-Amerika. Rocky Mountains → Noord-Amerika. Kilimanjaro → Afrika.",
        "solutionSteps": ["Himalaya = Azië (India/Nepal/China)", "Andes = Zuid-Amerika (Chili/Peru)", "Rocky Mountains = Noord-Amerika (VS/Canada)", "Kilimanjaro = Afrika (Tanzania)"]
      }
    }
  ]
}